import React from 'react';
import { useLocation } from 'react-router-dom';
import { ButtonClean, List, PriceString, Table, Tag, useMediaQueryContext, } from '@fourthwall/components';
import { TimezonedDateString } from '@modules/Timezone/components/TimezonedDateString';
import { useShopTime } from '@modules/Timezone/providers/ShopTimeProvider';
import { TAB_TITLES, tagsAppearances } from '../../consts';
import { ChargesHistoryListItem } from '../ChargesHistoryListItem/ChargesHistoryListItem';
import { PaymentMethod } from '../PaymentMethod/PaymentMethod';
export const getTableHeaders = (state, timezoneAbbreviation) => [
    {
        id: 'date',
        label: `Date (${timezoneAbbreviation})`,
        render: ({ date }) => React.createElement(TimezonedDateString, { date: date, format: "MMM DD, YYYY" }),
        width: 1.4,
    },
    {
        id: 'type',
        label: 'Type',
        render: ({ type }) => {
            if (type.url) {
                return React.createElement(ButtonClean, { to: type.url, state: state, label: type.label });
            }
            return type.label;
        },
        width: 1.3,
    },
    {
        id: 'amount',
        label: 'Amount',
        render: ({ amount }) => React.createElement(PriceString, { value: amount.value, currency: amount.currency }),
        width: 1.1,
    },
    {
        id: 'method',
        label: 'Method',
        render: ({ method }) => React.createElement(PaymentMethod, { method: method }),
        width: 1,
    },
    {
        id: 'status',
        label: 'Status',
        render: ({ status }) => React.createElement(Tag, { label: status, appearance: tagsAppearances[status] }),
        width: 1.3,
    },
];
export const ChargesHistoryData = ({ data, isLoading }) => {
    const location = useLocation();
    const media = useMediaQueryContext();
    const { timezoneAbbreviation } = useShopTime();
    const emptyMessage = "You haven't received any charges yet.";
    const locationState = {
        from: { label: TAB_TITLES.charges, location },
    };
    if (!media.tablet) {
        return (React.createElement(List, { data: data, isLoading: isLoading, emptyComponent: emptyMessage, renderItem: (chargesHistoryItem) => (React.createElement(ChargesHistoryListItem, { locationState: locationState, chargesHistoryItem: chargesHistoryItem })) }));
    }
    return (React.createElement(Table, { headers: getTableHeaders(locationState, timezoneAbbreviation), data: data, emptyMessage: emptyMessage, isLoading: isLoading, minWidth: 0 }));
};
